import Legal from '../Legal';
import Checkbox from '@material-ui/core/Checkbox';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import MenuSelector from '../../core/MenuSelector';
import SecondaryButton from '../../core/SecondaryButton';
import CancelButton from '../../core/CancelButton';
import TitledPanel from '../../core/TitledPanel';
import TitledTextField from '../../core/TitledTextField';
import { fullySanitiseText } from '../../core/utils/utils';
import PrimaryButton from '../PrimaryButton';
import { globalStyles as styles } from '../style/gstheme';

class AddSubscriptionDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            acceptConditions: false,
            isDuplicate: false,
            legal: false,
            option: props.selected || "",
            error: false,
            name: ""
        };
        this.cancellable = null;
        this.textInput = React.createRef();
    }

    handleClickOpen = () => this.setState({ open: true, acceptConditions: false });

    addSubscription = () => {
        const option = this.props.options.find(option => option.value === this.state.option);
        const productID = option.productID;
        this.setState({ open: false, name: "", option: "" });
        this.props.onAddSubscription({
            name: this.state.name.trim(),
            productID
        });
    };

    exitAddSubscription = () => this.setState({ open: false, name: "", option: "", acceptConditions: false });

    handleNameChange = (event) => {
        const t = event.target;
        const cleanText = fullySanitiseText(t.value);
        const isDuplicate = this.props.subscriptions.some(subscription => subscription.subscriptionName === cleanText);
        this.setState({ name: cleanText, isDuplicate });
    };

    handleUserChange = (option) => this.setState({ option });

    handleChangeConditions = (event) => this.setState({ acceptConditions: event.target.checked });

    showLegal = () => this.setState({ legal: true });

    exitLegal = () => this.setState({ legal: false });

    render() {

        const { name, isDuplicate, option, acceptConditions, legal } = this.state;
        const { classes, options, buttonTitle, inverted, selected, systemAdded } = this.props;
        const inComplete = option === "" || name === "";

        return (
            <React.Fragment>
                {inverted ?
                    <SecondaryButton dataTest="add-subscription" onClick={this.handleClickOpen}>{buttonTitle}</SecondaryButton>
                    :
                    <Button
                        data-test="add-subscription"
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        onClick={this.handleClickOpen}>{buttonTitle}</Button>
                }
                <Dialog
                    data-test="create-subscription"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paperWidthMd: classes.mediumDialog
                    }}
                    className={classes.dialog}
                    open={this.state.open}
                    onClose={this.exitAddSubscription}
                    aria-labelledby="addsubscription-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="addsubscription-dialog-title">Create Subscription</DialogTitle>
                    <DialogContent>
                        <form autoComplete="off" noValidate="novalidate">
                            <div style={{ marginBottom: 20 }}>
                                <TitledTextField
                                    dataTest="subscription-name"
                                    name="name"
                                    title="Name"
                                    autoFocus
                                    inputRef={this.textInput}
                                    error={isDuplicate}
                                    required={true}
                                    text={name}
                                    placeholder="Give your subscription a name"
                                    maxLength={100}
                                    errorText={isDuplicate ? "You already have a subscription with this name." : null}
                                    onChange={this.handleNameChange} />
                            </div>
                            <TitledPanel fontSize="large" height="full" title="Select Subscription Type Required">
                                <MenuSelector
                                    dataTest="subscription-type"
                                    handleChange={this.handleUserChange}
                                    selected={selected}
                                    options={selected ?
                                        options.filter(option => option.value === selected)
                                        :
                                        options} />
                            </TitledPanel>
                        </form>
                        {!systemAdded &&
                            <div style={{ paddingTop: 20 }}>
                                <Typography variant="body2">Please note Checkout will take you to our payment partner Paddle for completion of payment details. These details are not required for trials.</Typography>
                                <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
                                    <div style={{ display: 'flex' }}>
                                        <div>
                                            <Checkbox data-test="accept-ts-and-cs" checked={acceptConditions} onChange={this.handleChangeConditions} name="conditions" />
                                        </div>
                                        <div style={{ paddingTop: 12, textAlign: 'left' }}>
                                            <Typography className={classes.legalLink} style={{ textAlign: 'left' }} onClick={this.showLegal}>Accept Terms and Conditions</Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddSubscription}>Cancel</CancelButton>
                        <PrimaryButton disabled={inComplete || isDuplicate || (!systemAdded && !acceptConditions)} onClick={this.addSubscription}>{
                            systemAdded ?
                                "Add"
                                :
                                "Checkout"
                        }</PrimaryButton>
                    </DialogActions>
                </Dialog>
                {!systemAdded && <Legal open={legal} exitLegal={this.exitLegal} />}
            </React.Fragment>
        );
    }
}

AddSubscriptionDialog.defaultProps = {
    subscriptions: [],
    inverted: false,
    systemAdded: false,
    buttonTitle: 'Create Subscription'
};

AddSubscriptionDialog.propTypes = {
    classes: PropTypes.object,
    systemAdded: PropTypes.bool,
    inverted: PropTypes.bool,
    buttonTitle: PropTypes.string,
    options: PropTypes.array.isRequired,
    selected: PropTypes.string,
    subscriptions: PropTypes.array,
    onAddSubscription: PropTypes.func.isRequired
};

export default withStyles(styles)(AddSubscriptionDialog);
